<template>
    <div class="assetHandoverSetting-manage">
        <Paper class="assetHandoverSetting-manage-paper">
            <list-layout-paper>
                <template slot="header-search" class="searchBox">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        :showResetBtn="true"
                        @search-change="tableList.searchList"
                    />
                    <el-checkbox
                        class="table-checkAll"
                        v-if="operationType === 'add' || operationType === 'edit'"
                        :disabled="tableList.totalData.length === 0"
                        v-model="isAllChecked"
                    >
                        全选所有筛选的数据
                    </el-checkbox>
                </template>
                <template slot="header-button" v-if="operationType === 'add' || operationType === 'edit'">
                    <lotsButton
                        type="primary"
                        icon="el-icon-download"
                        size="mini"
                        title="导出用户资产"
                        :disabled="!tableList.totalData.length"
                        @click="exportUserAssets"
                    >
                        导出用户资产
                    </lotsButton>

                    <lots-upload-button
                        class="importBox"
                        text="导入"
                        :bucket="'annto-lcrm'"
                        :disabled="!tableList.totalData.length"
                        @callback="(data) => { upLoadFileUrl(data); }"
                    ></lots-upload-button>

                    <lotsButton
                        type="danger"
                        :disabled="selectedRows.length === 0 && !isAllChecked"
                        size="mini"
                        title="释放"
                        @click="releaseOpera"
                    >
                        释放
                    </lotsButton>

                    <lotsButton
                        type="primary"
                        icon="el-icon-user"
                        :disabled="selectedRows.length === 0 && !isAllChecked"
                        size="mini"
                        title="选择承接人"
                        @click="openAssigneeOpera"
                    >
                        选择承接人
                    </lotsButton>
                </template>
                <!-- 表格 -->
                <template v-slot:list>
                    <edit-table-box
                        ref="editTableBox"
                        key="assetHandover-clue"
                        v-loading="tableList.tableLoading"
                        :index="config.index"
                        :selection="config.selection"
                        :selectable="selectable"
                        :columns="config.columns"
                        height="448px"
                        :tableData="tableList.totalData"
                        :control="false"
                        :allowRowClick="false"
                        @selection-change="handleSelectionChange"
                        class="assetHandover-table-checkAll-Box"
                    >
                        <template v-slot:col-append="{ item, row, rIndex }">
                            <span v-if="['followStatus'].includes(item.prop)">
                                {{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey]) }}
                            </span>
                            <span v-if="['receiverName'].includes(item.prop)">
                                <lotsButton
                                    v-if="operationType === 'add' || operationType === 'edit'"
                                    @click="openAssigneeOpera(row)"
                                    type="text"
                                    size="mini"
                                    :title="row[item.prop]"
                                    :disabled="isAllChecked"
                                >
                                    {{ row[item.prop] ? row[item.prop] : '选择承接人' }}
                                </lotsButton>
                                <span v-else>{{ row[item.prop] }}</span>
                            </span>
                        </template>
                    </edit-table-box>
                </template>
                <template slot="footer">
                    <lots-pagination
                        :page-size.sync="tableList.pageSize"
                        @size-change="tableList.sizeChange"
                        :current-page.sync="tableList.pageNo"
                        @current-change="tableList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="tableList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>
        </Paper>

        <advanceUser ref='advanceUserRef' @confirm="selectAssigneeCallback"></advanceUser>
    </div>
</template>

<script>
import { ref, reactive, inject } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import searchBox from '@/components/lots/searchBox';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import editTableBox from '@/components/lots/editTableBox/Index';
import { getList, updateAssignee, batchUpdateAssignee, releaseToPublicPool, importAssignee } from '@/modules/mdm/api/customer/assetHandover/clue.js';
import { config as configStatic } from './config';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import lotsButton from '@/components/lots/lotsButton';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import advanceUser from '@/components/lots/otpAdvanceUser';
import { formatDictCodeToName } from '@/modules/mdm/utils.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import store from '@/store';
import { reportExport } from '@/modules/mdm/api/customer/assetHandover/index.js';

export default {
    name: 'assetHandover-clue',
    components: {
        Paper,
        searchBox,
        lotsButton,
        lotsUploadButton,
        listLayoutPaper,
        editTableBox,
        lotsPagination,
        advanceUser
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // 按钮权限
        const authorityCode = reactive(btnAuthority.monthProgressReport);

        // 暂存搜索条件
        const searchConditionCaChe = ref({});

        // 从父组件注入
        const operationType = inject('operaType'); // 操作类型
        const isAdminRole = inject('adminRole'); // 是否是管理员角色
        const exportOptions = inject('exportOpt'); // 导出选项
        const dictDatas = inject('dictDatasOpt'); // 字典数据
        const checkTransferNo = inject('checkTransferNo'); // 检查交接单是否存在
        const currentTransferNo = inject('transferNo'); // 交接单编号
        const currentTransferId = inject('transferNoId'); // 交接单id

        // 重置一次
        configStatic.selection = true;
        if (operationType.value === 'view') {
            configStatic.selection = false;
        }
        const config = reactive(configStatic);

        const searchDataFormat = (condition) => {
            condition.transferUser = currentUserCode.value; // 交接人mip号
            condition.transferNo = currentTransferNo.value; // 交接单编号
            // 优化属性遍历
            Object.keys(condition).forEach(key => {
                if (condition[key] === '' || condition[key] === null || condition[key] === undefined || condition[key].length === 0) {
                    delete condition[key];
                }
            });
            // 暂存搜索条件, 用于全选时使用
            searchConditionCaChe.value = condition;
            return condition;
        };

        class ListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };

            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        v.edit = -3;
                        return v;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                // 解决表格错位
                setupContext.root.$nextTick(() => {
                    const editTableBoxRef = setupContext.refs.editTableBox;
                    if (editTableBoxRef?.$refs?.moduleTable) {
                        editTableBoxRef.$refs.moduleTable.doLayout();
                    }
                });
            };
        };

        const tableList = new ListClass({
            Api: {
                listApi: getList // 查询接口
            },
            pageSize: 10
        });

        // 工具函数：转excelTitle对象
        const toExcelTitle = (item) => (item.name);

        // 导出用户资产
        const exportUserAssets = () => {
            const { user } = store.getters;
            const excelFileList = otherUtils.sortColumnsByFixed(config.columns)?.filter(it => it.property !== 'mobile' || it.property !== 'phone');
            const excelTitleList = excelFileList?.map(toExcelTitle);
            excelTitleList.unshift('ID');
            // 应后端要求在倒数第二个位置插入"承接人MIP"字段
            const insertIndex = excelTitleList.length - 1;
            excelTitleList.splice(insertIndex, 0, '承接人MIP');
            const params = {
                ...searchConditionCaChe.value,
                requestResults: excelTitleList.join(','),
                userCode: +isAdminRole.value ? undefined : user.userCode,
                adminRole: +isAdminRole.value,
                'tenantCode': 'annto',
                'applicationCode': 'APP202304140001',
                'applicationName': 'CRM',
                reportCode: exportOptions['report_lead']
            };
            Reflect.deleteProperty(params, 'pageSize');
            Reflect.deleteProperty(params, 'pageNo');
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            reportExport(params).then(res => {
                if (res && res.code === '0') {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            });
        };

        const upLoadFileUrl = async (res) => {
            try {
                await checkTransferNo();
                if (res && +res.code === 0 && res.data) {
                    importFile(res.data.downUrl, res.data.name);
                }
            } catch (error) {
                console.log('上传失败:', error);
            }
        };

        const importFile = async (url, name) => {
            try {
                tableList.tableLoading.value = true;
                const params = {
                    fileName: name,
                    fileUrl: url,
                    ownerCode: currentUserCode.value,
                    transferNo: currentTransferNo.value,
                    transferId: currentTransferId.value
                };
                const res = await importAssignee(params);
                if (res && res.code === '0') {
                    Message.success('导入成功');
                    tableList.getList();
                }
            } finally {
                tableList.tableLoading.value = false;
            }
        };

        // 释放
        const releaseOpera = () => {
            MessageBox.confirm('释放后，线索将回到公海池，请确认。', '温馨提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 全选状态下
                if (isAllChecked.value) {
                    allReleaseOpera();
                } else {
                    mulReleaseOpera();
                }
            });
        };

        // 多个释放
        const mulReleaseOpera = async () => {
            try {
                await checkTransferNo();
                tableList.tableLoading.value = true;
                const params = {
                    selectAllLead: false, // 是否全选
                    transferNo: currentTransferNo.value, // 交接单号
                    leadIdList: selectedRows.value.map(item => item.leadId) // 列表的线索idList
                };
                releaseToPublicPool(params).then(res => {
                    if (+res.code === 0) {
                        Message.success('释放成功');
                        tableList.getList();
                    }
                }).finally(() => {
                    tableList.tableLoading.value = false;
                });
            } catch (error) {
                console.log('操作失败:', error);
            }
        };

        // 所有搜索数据释放
        const allReleaseOpera = async () => {
            try {
                await checkTransferNo();
                tableList.tableLoading.value = true;
                const params = {
                    selectAllLead: true, // 是否全选
                    transferNo: currentTransferNo.value, // 交接单号
                    followStatusList: searchConditionCaChe.value.followStatusList // 全选的时候带上查询条件给到后端
                };
                releaseToPublicPool(params).then(res => {
                    if (+res.code === 0) {
                        Message.success('释放成功');
                        tableList.getList();
                    }
                }).finally(() => {
                    tableList.tableLoading.value = false;
                });
            } catch (error) {
                console.log('操作失败:', error);
            }
        };

        // 更改单个承接人
        const updateSingleAssigneeOpera = async () => {
            try {
                await checkTransferNo();
                tableList.tableLoading.value = true;
                const params = {
                    transferNo: currentTransferNo.value, // 交接单号
                    receiverCode: currentAssignee.value.userCode, // 承接人MIP
                    receiverName: currentAssignee.value.userName, // 承接人姓名
                    receiverDeptCode: currentAssignee.value.orgCode, // 承接人部门编码
                    receiverDeptName: currentAssignee.value.orgName, // 承接人部门名称
                    leadId: currentSelectRow.value.leadId, // 线索id
                    transferUser: currentUserCode.value // 交接人MIP
                };
                updateAssignee(params).then(res => {
                    if (+res.code === 0) {
                        Message.success('更改承接人成功');
                        tableList.getList();
                    }
                }).finally(() => {
                    tableList.tableLoading.value = false;
                });
            } catch (error) {
                console.log('操作失败:', error);
            }
        };

        // 更改多个承接人
        const updateMulAssigneeOpera = async () => {
            try {
                await checkTransferNo();
                tableList.tableLoading.value = true;
                const params = {
                    transferNo: currentTransferNo.value, // 交接单号
                    receiverCode: currentAssignee.value.userCode, // 承接人MIP
                    receiverName: currentAssignee.value.userName, // 承接人姓名
                    receiverDeptCode: currentAssignee.value.orgCode, // 承接人部门编码
                    receiverDeptName: currentAssignee.value.orgName, // 承接人部门名称
                    transferUser: currentUserCode.value, // 交接人MIP
                    leadIdList: selectedRows.value.map(item => item.leadId), // 列表的线索idList
                    selectAllLead: false // 是否全选
                };
                batchUpdateAssignee(params).then(res => {
                    if (+res.code === 0) {
                        Message.success('更改承接人成功');
                        tableList.getList();
                    }
                }).finally(() => {
                    tableList.tableLoading.value = false;
                });
            } catch (error) {
                console.log('操作失败:', error);
            }
        };

        // 更改所有搜索承接人
        const updateAllAssigneeOpera = async () => {
            try {
                await checkTransferNo();
                tableList.tableLoading.value = true;
                const params = {
                    transferNo: currentTransferNo.value, // 交接单号
                    receiverCode: currentAssignee.value.userCode, // 承接人MIP
                    receiverName: currentAssignee.value.userName, // 承接人姓名
                    receiverDeptCode: currentAssignee.value.orgCode, // 承接人部门编码
                    receiverDeptName: currentAssignee.value.orgName, // 承接人部门名称
                    transferUser: currentUserCode.value, // 交接人MIP
                    selectAllLead: true, // 是否全选
                    followStatusList: searchConditionCaChe.value.followStatusList // 全选的时候带上查询条件给到后端
                };
                batchUpdateAssignee(params).then(res => {
                    if (+res.code === 0) {
                        Message.success('更改承接人成功');
                        tableList.getList();
                    }
                }).finally(() => {
                    tableList.tableLoading.value = false;
                });
            } catch (error) {
                console.log('操作失败:', error);
            }
        };

        // 当前选择的行
        const currentSelectRow = ref({});
        // 打开选择承接人弹窗
        const openAssigneeOpera = (row) => {
            currentSelectRow.value = row;
            setupContext.refs.advanceUserRef.show();
        };

        // 当前选择的承接人
        const currentAssignee = ref({});
        const selectAssigneeCallback = (list) => {
            currentAssignee.value = list[0] || {};
            // 全选状态下
            if (isAllChecked.value) {
                updateAllAssigneeOpera();
            } else {
                (currentSelectRow.value && currentSelectRow.value.leadId) ? updateSingleAssigneeOpera() : updateMulAssigneeOpera();
            }
        };

        // 选择项
        const selectedRows = ref([]);
        const handleSelectionChange = (val) => {
            selectedRows.value = val;
        };

        // 是否全选所有数据
        const isAllChecked = ref(false);

        // 控制选择框是否可用
        const selectable = (row, index) => {
            return !isAllChecked.value;
        };

        // 交接人编码
        const currentUserCode = ref('');
        // 添加loadData方法
        const loadData = (code, transferNo) => {
            currentUserCode.value = code;
            tableList.getList();
        };

        return {
            tableList,
            config,
            handleSelectionChange,
            authorityCode,
            isAllChecked,
            selectedRows,
            openAssigneeOpera,
            selectAssigneeCallback,
            selectable,
            releaseOpera,
            exportUserAssets,
            upLoadFileUrl,
            loadData,
            dictDatas,
            formatDictCodeToName,
            operationType
        };
    }
};
</script>

<style lang="less" scoped>
.assetHandoverSetting-manage {
    width: 100%;

    ::v-deep .el-table__fixed .el-table__header thead tr th:first-child .cell .el-checkbox .el-checkbox__input {
        display: none;
    }

    .layout-content {
        box-shadow: none;
        padding: 0;
    }

    .table-checkAll {
        padding-left: 10px;
    }

    .assetHandoverSetting-manage-paper {
        height: 100%;
    }

    .list-layout {
        padding-top: 20px;
    }

    .flex-layout .list-main {
        overflow: auto;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .list-header {
        .assetHandoverSetting-manage-list-dropdown.el-dropdown {
            color: #fff;
        }
    }

    .layout-content.assetHandoverSetting-manage-paper {
        .el-table .cell.el-tooltip {
            &>div {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
    .importBox {
        display: inline-block;
        margin: 0 10px;
        vertical-align: bottom;
    }
}
</style>
